var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingNoValve = function SvgDCoolingNoValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46,363.5c-7.44,0-13.5-6.06-13.5-13.5s6.06-13.5,13.5-13.5,13.5,6.06,13.5,13.5-6.06,13.5-13.5,13.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,337c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M46,336c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,336.71c0,.13.05.26.15.36l13.5,13.15c.2.19.51.19.71,0,.19-.2.19-.52,0-.71l-13.5-13.15c-.2-.19-.51-.19-.71,0-.09.1-.14.22-.14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,349.86c0,.13.05.25.14.35.19.2.51.2.71,0l13.5-13.15c.2-.19.2-.51,0-.71-.19-.2-.51-.2-.71,0l-13.5,13.15c-.1.1-.15.23-.15.36Z"
  })))));
};
export default SvgDCoolingNoValve;